import { ConditionKind, Features } from "api/models";

export const FEATURES_POSSIBLE_CONDITIONS: Record<Features, ConditionKind[]> = {
  [Features.BROWSE_ABANDONMENT]: [ConditionKind.CUSTOMER_GROUP, ConditionKind.REVENUE],
  [Features.COME_BACK_MAILING]: [ConditionKind.CUSTOMER_GROUP, ConditionKind.REVENUE]
};
